import { useQuery } from "@tanstack/react-query";
import { taskApi } from "../api/tasks";
import { requireData } from "./http";

export const useShiftTaskOptions = (enabled: boolean, search: string, agentId: string) =>
  useQuery({
    queryKey: ["tasks", "shift-options", search, agentId],
    queryFn: () => taskApi.list({ search, agent_id: agentId }).then(requireData),
    enabled: enabled && Boolean(agentId),
  });
